(function () {
  'use strict';

  /* @ngdoc object
   * @name fuelPriceReport
   * @description
   *
   */
  angular
    .module('fuelPriceReport', [
      'ui.router'
    ]);
}());
